import { CaptomiOfficeRenderer } from './captomi_office';
import { DefaultRenderer } from './default';
import { LinkedInRenderer } from './linkedin';
import type { AppRenderer } from './types';

const RENDERERS: Record<string, AppRenderer> = {
  linkedin: LinkedInRenderer,
  captomi_office: CaptomiOfficeRenderer,
};

export function get_renderer(app_name: string): AppRenderer {
  return RENDERERS[app_name] ?? DefaultRenderer;
}

export type { AppRenderer, AppPayload, SubcollectionDoc } from './types';
